import React, { useState, useEffect, Suspense } from "react";
import { apiService } from "../../../api/apiAdapter";

const Footer = React.lazy(() => import("../../../components/footer"));

let xeroTokenSetPromise = null;

const XeroAuthResponse = (props) => {
  const [tokenSet, setTokenSet] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code) {
      // First mount: consume the code, clean the URL, start the API call.
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("code");
      cleanUrl.searchParams.delete("state");
      window.history.replaceState({}, "", cleanUrl.toString());

      xeroTokenSetPromise = apiService.exchangeXeroAuthorizationCode(code);
    }

    // Both mounts subscribe to the same promise so the StrictMode remount
    // (which finds no code) still receives the resolved token set.
    if (!xeroTokenSetPromise) return;

    xeroTokenSetPromise
      .then(setTokenSet)
      .catch((error) => console.error("Failed to store Xero token set:", error));
  }, []);

  return (
    <Suspense fallback={<div className="loader"></div>}>
      <div className="container" style={{ height: "50vh" }}>
        Please check in dataverse for the token set below:
        {tokenSet && (
          <div>
            <p>Access Token: {tokenSet.access_token}</p>
            <p>Refresh Token: {tokenSet.refresh_token}</p>
            <p>Id Token: {tokenSet.id_token}</p>
            <p> expires at: {tokenSet.expires_at}</p>
            <p>Scope: {tokenSet.scope}</p>
            <p> Token type: {tokenSet.token_type}</p>
          </div>
        )}
      </div>
      <Footer />
    </Suspense>
  );
};

export default XeroAuthResponse;
